import gql from 'graphql-tag';
import { getAxios, getGraphql } from './apiUtils';
import * as R from 'ramda';
import { EMAIL_TEMPLATE_FIELDS } from './fragments';

// USER
export const addUser = async user => {
  try {
    return await getAxios()
      .post('/api/auth/user', user)
      .then(res => res.data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateUser = async user => {
  try {
    return await getAxios().put('/api/user', user);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getUsers = async () => {
  try {
    const users = await getAxios().get('/api/user');
    return users.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// USER GROUPS

export const addUserGroup = async group => {
  try {
    return await getAxios().post('/api/user-group', group);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateUserGroup = async group => {
  try {
    return await getAxios().put('/api/user-group', group);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserGroups = async () => {
  try {
    const groups = await getAxios().get('/api/user-group');
    return groups.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// ROLES

export const addUserRole = async role => {
  try {
    return await getAxios().post('/api/user-role', role);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const removeUserRole = async dto => {
  try {
    return await getAxios().post('/api/user-role/remove', dto);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserRoles = async () => {
  try {
    const roles = await getAxios().get('/api/user-role');
    return roles.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// SITES

export const addSite = async site => {
  try {
    await getAxios().post('/api/site', site);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateSite = async dto => {
  try {
    await getAxios().put('/api/site', dto);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSites = async () => {
  try {
    const roles = await getAxios().get('/api/site');
    return roles.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getEmailTemplates = async () => {
  const query = gql`
    ${EMAIL_TEMPLATE_FIELDS}
    query GET_EMAIL_TEMPLATES {
      emailTemplates(sorting: [{ field: description, direction: ASC }, { field: siteId, direction: ASC }]) {
        ...EmailTemplateFields
      }
    }
  `;

  return getGraphql()
    .query({ query })
    .then(R.path(['data', 'emailTemplates']));
};

export const getEmailTemplateById = async id => {
  try {
    const roles = await getAxios().get('/api/email-template/' + id);
    return roles.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addEmailTemplate = async template => {
  try {
    const roles = await getAxios().post('/api/email-template/', template);
    return roles.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateEmailTemplate = async template => {
  try {
    const mutation = gql`
      ${EMAIL_TEMPLATE_FIELDS}
      mutation UPDATE_EMAIL_TEMPLATE($id: ID!, $email: UpdateEmailTemplate!) {
        updateOneEmailTemplate(input: { id: $id, update: $email }) {
          ...EmailTemplateFields
        }
      }
    `;

    const { id, ...email } = template;

    return getGraphql()
      .mutate({ mutation, variables: { id, email } })
      .then(R.path(['data', 'updateOneEmailTemplate']));
  } catch (error) {
    throw new Error(error.message);
  }
};
